import { heroImage } from "@/mocks/webtoons";

interface HeroProps {
  query: string;
  onSearch: (q: string) => void;
}

export default function Hero({ query, onSearch }: HeroProps) {
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    document.getElementById("list")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroImage}
          alt="韩漫推荐编辑精选插画背景"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/70 via-background-50/55 to-background-50"></div>
      </div>

      <div className="relative mx-auto flex w-full max-w-4xl flex-col items-center px-4 pb-16 pt-32 text-center md:px-6 md:pb-20 md:pt-40">
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-medium text-secondary-900">
          <i className="ri-fire-line text-sm"></i>
          每周口碑榜单 · 帮你避开烂尾雷区
        </span>

        <h1 className="mt-6 font-heading text-3xl font-bold leading-snug text-foreground-950 md:text-5xl md:leading-tight">
          好看的韩漫推荐
          <span className="block text-primary-600">评分高 · 口碑好 · 不踩雷</span>
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-foreground-700 md:text-lg">
          精心整理的韩漫推荐评分高作品，参考豆瓣评分与读者好评，人气与经典并存。
          无论你想看治愈日常、烧脑悬疑还是热血高能，这里都有一份放心入坑的片单。
        </p>

        <form
          onSubmit={submit}
          className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row sm:items-center"
        >
          <div className="relative flex-1">
            <i className="ri-search-line pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-lg text-foreground-500"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => onSearch(e.target.value)}
              placeholder="搜索：玄幻、治愈、校园恋爱…"
              className="h-12 w-full rounded-full border border-background-300 bg-background-50 pl-12 pr-4 text-sm text-foreground-950 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
          </div>
          <button
            type="submit"
            className="h-12 whitespace-nowrap rounded-full bg-primary-500 px-7 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            开始找漫
          </button>
        </form>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-foreground-700">
          <span className="inline-flex items-center gap-2">
            <i className="ri-archive-line text-lg text-primary-600"></i>
            收录 120+ 部高分佳作
          </span>
          <span className="inline-flex items-center gap-2">
            <i className="ri-star-fill text-lg text-secondary-500"></i>
            平均站内评分 9.0+
          </span>
          <span className="inline-flex items-center gap-2">
            <i className="ri-checkbox-circle-line text-lg text-accent-600"></i>
            每部都经过编辑试读
          </span>
        </div>
      </div>
    </section>
  );
}